export const setPrimaryColor = (primaryColor) => {
  document.documentElement.style.setProperty('--primary-color', primaryColor ?? '#0c243f');
}

export const setAccentColor = (accentColor) => {
  document.documentElement.style.setProperty('--secondary-color', accentColor ?? '#000000');
}

